import { CustomFieldClassType } from '@cims-online/shared'
import { ProjectCustomFieldsProvider } from 'components/CustomFields/ProjectCustomFieldsContext'
import { FDCTrackerProvider } from './FDCTrackerContext'
import FDCTrackerTable from './components/FDCTrackerTable'
import PayItemSelectProvider from 'components/CIMSSelect/common/PayItemSelect/PayItemSelectContext'
import { WithPayItemGlobalId } from 'components/CIMSTable/components/HeaderActionButtons/types'
import { DesignSubmittalLogProvider } from '../../../DesignSubmittals/components/DesignSubmittalLog/DesignSubmittalLogContext'

const FDCTracker: React.FC<WithPayItemGlobalId> = ({ payItemGlobalId }) => (
  <ProjectCustomFieldsProvider
    classType={CustomFieldClassType.FieldDesignChange}
  >
    <PayItemSelectProvider>
      <DesignSubmittalLogProvider>
        <FDCTrackerProvider payItemGlobalId={payItemGlobalId}>
          <FDCTrackerTable />
        </FDCTrackerProvider>
      </DesignSubmittalLogProvider>
    </PayItemSelectProvider>
  </ProjectCustomFieldsProvider>
)

export default FDCTracker
